import gApi from '@api/chang_su/consultGiftApi'
import { PRIVILEGE_CONSULT_GIFT, SHOP_PRODUCTS_PATH_A } from '@constant'
import { isProfessional, isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { message, Modal } from 'hljd'
import { action, observable } from 'mobx'
import indexStore from '../Tabs/store'

const confirm = Modal.confirm

class Store {
  @observable gift_content
  @observable gift_status
  @observable gift_reason

  @observable
  giftModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @action
  onCancelGift = () => {
    this.giftModal.isShow = false
  }

  @action
  getGift = async key => {
    let { data, success } = await gApi.getConsultGiftConfig({ id: key })
    if (success) {
      this.gift_content = data.content
      this.gift_reason = data.reason
    }
  }

  openConsultGift = () => {
    if (!isUltimate() && !isProfessional()) {
      this.giftModal = {
        type: 2,
        isShow: true,
        content: `无法使用此功能，请升级至${getProTitle()}！`,
        btn1: '关闭',
        btn2: '了解详情',
        hrefVal: SHOP_PRODUCTS_PATH_A
      }
    } else {
      window.location.href = '#/localMerchant/marketingTools/setConsultGift'
    }
  }

  @action
  closeConsultGift = () => {
    const { gift_content } = this
    let params = {
      grade_privilege_id: PRIVILEGE_CONSULT_GIFT,
      content: gift_content,
      status: 0
    }

    confirm({
      title: '确定要关闭咨询礼？',
      onOk: async () => {
        let { success } = await gApi.editConsultGiftConfig(params)
        if (success) {
          message.success('操作成功！')
          indexStore.getTabInfo()
          // indexStore.getGift(1)
          this.getGift(PRIVILEGE_CONSULT_GIFT)
        }
      }
    })
  }
}
export default new Store()
